'use strict';

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
var Add = require('../../node_modules/@material-ui/icons/Add.js');
var Button = require('../../node_modules/@material-ui/core/esm/Button/Button.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _dec, _class;
var styles = {
  inputButton: {
    display: 'none'
  },
  addButton: {
    height: 110,
    width: 110,
    textAlign: 'center'
  }
};
var UploadPhotoButton = (_dec = withStyles(styles), _dec(_class =
/*#__PURE__*/
function (_PureComponent) {
  inherits(UploadPhotoButton, _PureComponent);

  function UploadPhotoButton() {
    classCallCheck(this, UploadPhotoButton);

    return possibleConstructorReturn(this, getPrototypeOf(UploadPhotoButton).apply(this, arguments));
  }

  createClass(UploadPhotoButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          handlePhotoUpload = _this$props.handlePhotoUpload;
      return React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement("input", {
        id: "photo-upload",
        accept: "image/*",
        type: "file",
        multiple: true,
        className: classes.inputButton,
        onChange: function onChange(event) {
          event.preventDefault();
          handlePhotoUpload(event);
        }
      }), React__default["default"].createElement("label", {
        htmlFor: "photo-upload"
      }, React__default["default"].createElement(Button["default"], {
        variant: "outlined",
        component: "span",
        color: "primary",
        className: classes.addButton
      }, React__default["default"].createElement(Add, {
        className: classes.addIcon
      }))));
    }
  }]);

  return UploadPhotoButton;
}(React.PureComponent)) || _class);

module.exports = UploadPhotoButton;
